import { EvidenceLink } from '@shared/utils/evidence-management';
import { EvidenceDetailsActionResult } from '../models/evidence-action-result.models';
import { EvidenceAndPreview, Location } from '../models/evidence.models';

export const EVIDENCE_STORE_KEY = 'evidence';

export interface IEvidenceState {
  evidenceUid: string | null;
  evidenceAndPreview: EvidenceAndPreview | null;
  preview: string | null;
  actionResult: EvidenceDetailsActionResult | null;
  isLoading: boolean;
  location: Location | null;
  isLocationLoading: boolean;
  links: EvidenceLink[] | null;
  isLockCodeRequired: boolean;
}

export const initialState: IEvidenceState = {
  evidenceUid: null,
  evidenceAndPreview: null,
  preview: null,
  actionResult: null,
  isLoading: false,
  location: null,
  isLocationLoading: false,
  links: null,
  isLockCodeRequired: false,
};
